<template lang="pug">
  b-card(no-body class="historial-card mt-3")
    b-card-body
      b-row.row-title.pb-3
        b-icon-clock-history.mr-2.title
        h3.title Historial
      
      .timeline-list
        .timeline-item(v-for="(item, index) in displayedHistorial" :key="index")
          .timeline-marker
            .dot
            .line(v-if="index !== displayedHistorial.length - 1")
          .timeline-content
            .date-time {{ item.fecha_hora }}
            .action-text *{{ item.accion }}*
            .user-text "{{ item.usuario }}"
      
      b-row.load-more-row(v-if="canLoadMore")
        a.load-more-link(@click="showAll = true") Cargar el historial completo
</template>

<script>
export default {
  name: 'TabOVHistorial',
  props: {
    ov: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      showAll: false,
      initialItems: 4, // Show slightly more items by default in vertical list
    }
  },

  computed: {
    ovData() {
      const historial = Array.isArray(this.ov.historial_completo)
        ? this.ov.historial_completo.map((item) => {
            let fechaFormateada = '-'
            if (item.fecha_hora) {
              const fecha = new Date(item.fecha_hora)
              fechaFormateada = `${fecha.toLocaleString('es-CL', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
              })} Hrs`
            }
            return {
              fecha_hora: fechaFormateada,
              tipo:
                item.tipo === 'CAMBIO_ESTADO' ? 'Cambio de Estado' : 'Acción',
              accion: item.accion,
              estado_actual: item.estado_actual || '-',
              estado_anterior: item.estado_anterior || '-',
              usuario: item.responsable?.nombre_completo || '-',
            }
          })
        : []
      return {
        historial_acciones: historial,
      }
    },
    displayedHistorial() {
      if (this.showAll) {
        return this.ovData.historial_acciones
      }
      return this.ovData.historial_acciones.slice(0, this.initialItems)
    },
    canLoadMore() {
      return (
        !this.showAll &&
        this.ovData.historial_acciones.length > this.initialItems
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.historial-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.title {
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0;
  color: #23201c;
}

.row-title {
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
}

.timeline-list {
  display: flex;
  flex-direction: column;
  padding-left: 10px;
}

.timeline-item {
  display: flex;
  gap: 15px;
  position: relative;
  padding-bottom: 25px;

  &:last-child {
    padding-bottom: 0;
  }
}

.timeline-marker {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 20px;
  position: relative;

  .dot {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: $samtek-yellow; // Or generic gray if preferred, yellow matches brand
    z-index: 2;
    margin-top: 4px; // Align with first line of text
  }

  .line {
    position: absolute;
    top: 18px;
    bottom: -25px; // Extend to next item
    width: 2px;
    background-color: #e9ecef;
    z-index: 1;
  }
}

.timeline-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.date-time {
  font-size: 0.9rem;
  font-weight: 700;
  color: #23201c;
}

.action-text {
  font-size: 0.9rem;
  color: #525252;
}

.user-text {
  font-size: 0.85rem;
  color: #888;
  font-style: italic;
}

.load-more-row {
  padding: 15px;
  justify-content: flex-start;
}

.load-more-link {
  color: $blue-accent;
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;

  &:hover {
    color: darken($blue-accent, 10%);
  }
}
</style>
